export default __webpack_public_path__ + "static/media/student_avatar.b745aba4.png";